import { SvgIcon, SxProps } from "@mui/material";
import IconSvg from "jsx:../../../Images/Icons/FontAwesome/solid/message-question.svg";

export function MessageQuestionIcon(props: SxProps) {
    return <SvgIcon component={IconSvg} inheritViewBox sx={props} />;
}
